import { Image, List } from 'antd';
import { PureComponent } from 'react';
import VirtualList from 'rc-virtual-list';
import { Template } from '../../../../api/getAttachmentTemplatesForDoctor';

type Props = {
    onSendTemplateClick: (template: Template) => void;
    deleteAttachment: (id: string) => void;
    onHideAttachment: () => void;
    templates: Template[];
    templateApplyText?: string;
    templateApplyIcon?: JSX.Element;
};

export class AttachmentTemplateList extends PureComponent<Props> {
    onTemplateApply = (item: Template) => {
        const { onSendTemplateClick, onHideAttachment } = this.props;
        onSendTemplateClick(item);
        onHideAttachment();
    };

    render() {
        const { templates, templateApplyText, templateApplyIcon } = this.props;
        const { deleteAttachment } = this.props;

        return (
            <List className="hide-scrollbar h-full overflow-auto">
                <VirtualList
                    className="hide-scrollbar overflow-auto"
                    data={templates}
                    itemHeight={47}
                    itemKey="email"
                >
                    {(item: Template) => (
                        <List.Item
                            key={item._id}
                            className="px-16 cursor-pointer hover:bg-darwin-neutral-50"
                        >
                            <List.Item.Meta
                                title={item?.meta?.display?.title}
                                description={item?.meta?.display?.description}
                            />
                            <div className="flex items-center space-x-8">
                                {item?.meta?.display?.file_type ? (
                                    item?.meta?.display?.file_type === 'IMG' ? (
                                        <Image
                                            className="border border-darwin-neutral-200"
                                            width={81}
                                            height={50}
                                            preview={{
                                                mask: (
                                                    <span
                                                        role="img"
                                                        aria-label="eye"
                                                        className="anticon anticon-eye"
                                                    >
                                                        <svg
                                                            viewBox="64 64 896 896"
                                                            focusable="false"
                                                            data-icon="eye"
                                                            width="1em"
                                                            height="1em"
                                                            fill="currentColor"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
                                                        </svg>
                                                    </span>
                                                ),
                                            }}
                                            src={item?.meta?.display?.link}
                                        />
                                    ) : (
                                        <a
                                            className="text-darwin-primary-500 font-700"
                                            href={item?.meta?.display?.link}
                                            target="_blank"
                                        >
                                            <i>file link</i>
                                        </a>
                                    )
                                ) : null}
                                <p className="h-32 w-1 bg-darwin-neutral-400"></p>
                                <svg
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        deleteAttachment(item._id);
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="w-16 h-16 fill-darwin-status-warning-500  hover:opacity-80"
                                >
                                    <path d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z" />
                                </svg>
                                <p className="h-32 w-1 bg-darwin-neutral-400"></p>
                                <button
                                    className="space-x-8 hover:opacity-70 flex px-12 py-5 secondary-btn btn--small cursor-pointer items-center"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.onTemplateApply(item);
                                    }}
                                >
                                    <span>{templateApplyText}</span>
                                    {templateApplyIcon}
                                </button>
                            </div>
                        </List.Item>
                    )}
                </VirtualList>
            </List>
        );
    }
}

export default AttachmentTemplateList;
